import { render, staticRenderFns } from "./CreateOrUpdate.vue?vue&type=template&id=48d46181&scoped=true"
import script from "./CreateOrUpdate.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdate.vue?vue&type=script&lang=js"
import style0 from "./CreateOrUpdate.vue?vue&type=style&index=0&id=48d46181&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d46181",
  null
  
)

export default component.exports